import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import type { UserState } from '@/interfaces/administration/management/userManagement';

const state: UserState = {};

const mutations = {
    setUserState(state: UserState, user: UserState) {
        Object.assign(state, user);
    },
    resetUserState(state: UserState) {
        Object.keys(state).forEach((key) => {
            delete state[key];
        });
    },
};

// !!!!!!!!!!!!!!!!!!!! TODO !!!!!!!!!!!!!!!!!!!!
// Quand on aura la page LOGIN opérationnelle
// Il faudra set tous les user Info dans le store et modifier l'id qui est codé en dur
const actions = {
    async setUserInfo(
        {
            commit,
        }: {
            commit: (mutation: string, payload?: object | undefined) => void;
        },
        user: UserState,
    ) {
        commit('setUserState', user);
    },
    resetUserInfo({ commit }: { commit: (mutation: string, payload?: unknown) => void }) {
        commit('resetUserState');
    },
};

const getters = {
    userInfo: (state: UserState) => {
        return state;
    },
};

const userModule: Module<UserState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default userModule;
